import { useCallback, useEffect, useState } from 'react';
export let LocalStorageKey;
(function (LocalStorageKey) {
  LocalStorageKey["TICKET_LISTINGS_COLUMN_SIZING"] = "hs:cp:ticket-listings:column-sizing";
})(LocalStorageKey || (LocalStorageKey = {}));
const STORAGE_EVENT_NAME = 'hs:cp:storage';

/**
 *
 * @param key - The key to store the value in localStorage
 * @param initialValue - The initial value to use if the value is not found in localStorage
 * @returns A tuple containing the current value and a function to update the value
 * In addition, the value will be synced across tabs/windows listening to the same key.
 */
export function useLocalStorageJSON(key, initialValue) {
  const [value, _setValue] = useState(() => {
    try {
      const item = localStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      return initialValue;
    }
  });
  const setValue = useCallback(newValue => {
    _setValue(newValue);
    try {
      if (newValue === undefined) {
        localStorage.removeItem(key);
      } else {
        localStorage.setItem(key, JSON.stringify(newValue));
      }
      window.postMessage({
        type: STORAGE_EVENT_NAME,
        key,
        value: JSON.stringify(newValue)
      }, '*');
    } catch (_unused) {
      // Do nothing
    }
  }, [key]);
  useEffect(() => {
    const onStorageEvent = e => {
      if (e.data.type !== STORAGE_EVENT_NAME) return;
      if (e.data.key === key) {
        _setValue(JSON.parse(e.data.value));
      }
    };
    window.addEventListener('message', onStorageEvent);
    return () => window.removeEventListener('message', onStorageEvent);
  }, [key]);
  return [value, setValue];
}